import { useState, useEffect } from "react";
import { useNavigate } from "react-router";

import axios from "axios";

import Swal from "sweetalert2";
import { questionModal, successModal } from "../../Components/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faPlusCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";

import "./style.css";
import BASEURL, { FE_BASE_URL } from "../../Config/global";
import { placeholderImage } from "../../Assets/images";
import CustomInput from "../../Components/CustomInput";
import CustomLoader from "../../Components/CustomLoader";


import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from "draft-convert";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Modal } from "react-bootstrap";
import moment from "moment";
import { postRequest } from "../../Util/requests";




const AddInfobox = () => {
  const navigate = useNavigate();
  const [inputValue, setinputValue] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [soundImage, setSoundImage] = useState(null);
  const [target, setTarget] = useState(false);
  const [unlimited, setUnlimited] = useState(false);
  const [minDate, setMinDate] = useState(new Date());

  const [formData, setFormData] = useState({});
  const [formImgShow, setFormImgShow] = useState({});
  const [loginError, setLoginError] = useState({ error: false, text: "" });
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('english');

  
  const [test, setTest] = useState('');

  const [priEditorState, setPriEditorState] = useState(
    () => EditorState.createEmpty(),
  );

  const [secEditorState, setSecEditorState] = useState(
    () => EditorState.createEmpty(),
  );


  useEffect(() => {
    // 2018-12-31
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    setMinDate(year + '-' + month + '-' + day)
  }, [])


  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const postData = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append("slider_name", formData.slider_name);
    // HTML info tray
    formDataToSend.append("company_title", formData.company_title);
    (formData.header_logo_info != undefined && formData.header_logo_info != null) && formDataToSend.append("header_logo_info", formData.header_logo_info);
    (formData.mobile_logo != undefined && formData.mobile_logo != null) && formDataToSend.append("mobile_logo", formData.mobile_logo);
    (formData.desktop_logo != undefined && formData.desktop_logo != null) && formDataToSend.append("desktop_logo", formData.desktop_logo);
    formDataToSend.append("html_info_text", formData.html_info_text);
    formDataToSend.append("language", selectedLanguage);
    setLoader(true);

    try {
      const response = await postRequest(`/api/user/infoboxes/`, formDataToSend, null)
      if (!response.data.error) {
        successModal.fire({
          text: "Info Box Added Successfully",
          confirmButtonText: "Continue",
        });
        setLoginError({ error: false, text: "" });
        setLoader(false);
        navigate("/infobox-management");
      } else {
        setLoginError({ error: true, text: response.data.message });
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData);
    if (formData.slider_name) {
      questionModal
        .fire({
          title: "Do you want to add this <br/> Info Box?",
          confirmButtonText: "Add",
        })
        .then((result) => {
          if (result.isConfirmed) {
            postData();
            // console.log(formData)
          }
        });
    }
    else {
      setLoginError({ error: true, text: "Please Fill All the Requires Fields" });
    }
  };

  // useEffect(() => {
  //   let html = draftToHtml(convertToRaw(priEditorState.getCurrentContent()));
  //   // console.log(html)
  //   setFormData({ ...formData, 'html_info_text': html });
  // }, [priEditorState]);

  // useEffect(() => {
  //   let html = draftToHtml(convertToRaw(secEditorState.getCurrentContent()));
  //   setFormData({ ...formData, 'sec_html_info_text': html });
  // }, [secEditorState]);

  const regex = "^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\\d\\d$";

  const changeMe = (e) => {
    console.log(e, 'change')
    if (e.target.value.length == 2) {
      setTest(e.target.value + '/')
    } else if (e.target.value.length == 5) {
      setTest(e.target.value + '/')
    } else if (e.target.value.length <= 10 || e.target.value.length == '') {
      setTest(e.target.value)
    }
  }

  const inputMe = (e) => {
    if (e.keyCode == 8) {
      setTimeout(() => {
        // console.log(test.slice(0, -1));
        if (e.target.value.length == 3) {
          console.log(test.slice(0, -2));
          setTest(e.target.value.slice(0, -2))
        }
      }, 500);
    }
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    // setFormData({ ...formData, [event.target.name]: file });
    setFormData({ ...formData, [event.target.name]: file });
    if (file === null || file === "undefined") {
      setFormImgShow({ ...formImgShow, [event.target.name]: null });
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // setSoundImage(reader.result);
        // const { name, value } = event.target;
        setFormImgShow({ ...formImgShow, [event.target.name]: reader.result });
        // form.header_logo_info(reader.result)
        // console.log(formData)
      };
    }
  }

  const handleCopy = () => {
    const text = `${FE_BASE_URL}/${isCopied}/${formData.code}`
    navigator.clipboard.writeText(text);
    setShowModal(false)
  }
  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12 mb-2">
              <h2 className="mainTitle">
                <BackButton />
                Add Info Box
              </h2>
            </div>
          </div>
          {/* <input onKeyDown={inputMe} onChange={changeMe} type="text" value={test} /> */}
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">

              {/* Coupon Fields */}
              <div className="col-lg-3 mb-2">
                <CustomInput
                  label="Slider Name"
                  labelClass="mainLabel"
                  type="text"
                  name="slider_name"
                  value={formData.slider_name || ""}
                  inputClass="mainInput"
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <CustomInput
                  label="Created Date"
                  labelClass="mainLabel"
                  type="text"
                  name="created"
                  value={moment().format('MM/DD/YYYY')}
                  inputClass="mainInput"
                  // onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <CustomInput
                  label="Modified Date"
                  labelClass="mainLabel"
                  type="text"
                  name="updated"
                  value={moment().format('MM/DD/YYYY')}
                  inputClass="mainInput"
                  // onChange={handleChange}
                />
              </div>
              {/* <div className="col-lg-3 mb-2" style={{ display: 'none' }}>
                <p className="mainLabel">Select Language*</p>
                <select
                  name="language"
                  id="language"
                  className="mainInput w-100"
                  value={selectedLanguage}
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                >
                  <option value="english">English</option>
                  <option value="spanish">Spanish</option>
                </select>
              </div> */}



             

              {/* Primary User */}
              <div className="col-lg-3 mb-2">
                <CustomInput
                  label="Company Title"
                  labelClass="mainLabel mb-3"
                  type="text"
                  name="company_title"
                  value={formData.company_title || ""}
                  placeholder="Enter Company Title"
                  inputClass="mainInput"
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <label className="w-100">
                  <p className="mainLabel">Header Information Image</p>
                  <div className="imageInput couponImageInput">
                    {formImgShow?.header_logo_info ? (
                      <img src={formImgShow?.header_logo_info} className="img" alt="Main" />
                    ) : (
                      <img src={placeholderImage} alt="Main" />
                    )}
                  </div>
                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    className="d-none"
                    name="header_logo_info"
                    onChange={handleImageChange}
                  />
                </label>
              </div>
              <div className="col-lg-3 mb-2">
                <label className="w-100">
                  <p className="mainLabel">Mobile Image</p>
                  <div className="imageInput couponImageInput">
                    {formImgShow?.mobile_logo ? (
                      <img src={formImgShow?.mobile_logo} className="img" alt="Main" />
                    ) : (
                      <img src={placeholderImage} alt="Main" />
                    )}
                  </div>
                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    className="d-none"
                    name="mobile_logo"
                    onChange={handleImageChange}
                  />
                </label>
              </div>
              <div className="col-lg-3 mb-2">
                <label className="w-100">
                  <p className="mainLabel">Desktop Image</p>
                  <div className="imageInput couponImageInput">
                    {formImgShow?.desktop_logo ? (
                      <img src={formImgShow?.desktop_logo} className="img" alt="Main" />
                    ) : (
                      <img src={placeholderImage} alt="Main" />
                    )}
                  </div>
                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    className="d-none"
                    name="desktop_logo"
                    onChange={handleImageChange}
                  />
                </label>
              </div>

              <div className="col-lg-12 mb-2">
                <div className="inputWrapper">
                  <label className="mainLabel">HTML Information</label>
                  <textarea
                    rows="10"
                    placeholder=""
                    required=""
                    name="html_info_text"
                    className="mainInput"
                    value={formData.html_info_text}
                    onChange={handleChange}
                  ></textarea></div>
              </div>


              {/* <div className="col-lg-12">
                <div className="App" >
                  <label class="mainLabel">HTML Information</label>
                  <Editor
                    editorState={priEditorState}
                    onEditorStateChange={setPriEditorState}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                    toolbar={{
                      options: ['inline', 'colorPicker', 'link', 'embedded', 'image', 'blockType', 'fontSize', 'list', 'textAlign', 'remove'],
                      link: {
                        showOpenOptionOnHover: true,
                      },
                      inline: {
                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                      },
                    }}
                  />


                </div>
              </div> */}

           


            </div>

            {loginError.error == true && (
              <div className="row mb-3">
                <div className="col-12">
                  <p className="secondaryText">{loginError.text}</p>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12">
                <CustomButton
                  type="submit"
                  variant="primaryButton"
                  text="Add Info Box"
                />
              </div>
            </div>

          </form>
        </div>
      </DashboardLayout >
      {loader && <CustomLoader />}
      <Modal
        show={showModal}
        centered
        className="swap-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="pb-5 w-100 d-flex flex-column align-items-center">
            <div className="text-end ms-auto">
              <button
                className="closeButton notButton ms-auto"
                onClick={() => { setShowModal(false); }}
              >
                
              </button>
            </div>
            <div className="w-100 d-flex flex-column align-items-center" style={{ maxWidth: '500px' }}>
              <div className="d-flex align-items-center mt-3 pt-3 flex-column">
                <h2 className="mb-0 me-4"><b className="mx-2">{"Copy Url"}</b></h2>
                <br />
                {
                  `${FE_BASE_URL}/${isCopied}/${formData.code}`
                }
              </div>
            </div>
            <div className="mt-3 pt-3 d-flex gap-3 justify-content-center">
              <FontAwesomeIcon
                className="mx-2"
                size={"2xl"}
                icon={faCopy}
                onClick={() => handleCopy()}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};
export default AddInfobox;
